import React, { useState, createRef, useEffect } from "react";

import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2'
import config from "../../config"
import { useNetworkState } from 'react-use';


const Register = () => {
  let navigate = useNavigate();
  const isOnline = useNetworkState();
  let location = useLocation();
  console.log("isONline  === ", isOnline)
  let userDetail = localStorage.getItem('ship_rocket_user');

  // console.log("userDetail ===>   ",userDetail);
  const [state, setState] = useState({ email: "", password: "" });
  const [regsterState, setRegsterState] = useState({ email: "", password: "", full_name: "", company_name: "", mobile_number: "", referral_code: "" , state:"" , city:"" });
  const [userState, setUserState] = useState({ full_name: "" });
  const [trackState, setTrackState] = useState({ tracking_no: "" })
  const [countrylist , setcountrylist]= React.useState([])
  const [statelist , setstatelist]= React.useState([])
  const [citylist , setcitylist]= React.useState([])
  React.useEffect(() => {
   
    stateList();
  }, []);

  
  const stateList = () =>{
    
    let full_api = config.apiUrl + `/country/state_list`;
    let sendData= {t_country_id:244};
    axios.post(full_api, sendData, { headers: config.headers }).then((res) => {
        setstatelist(res.data.output)
     }).catch((e) => {
        // setIsLoading(false)
  
    });
  }
 
  const handleSelectState = (e)=>{
     setRegsterState({ ...regsterState, state:e.target.value });
    // let full_api = config.apiUrl + `/country/all_city_list`;
    // let sendData= { state_id:e.target.value};
    // axios.post(full_api, sendData, { headers: config.headers }).then((res) => {
    //     setcitylist(res.data.output)
    //  }).catch((e) => {
    //  });
  }
  
  
  const handleSelectCity = (e)=>{
     setRegsterState({ ...regsterState, city:e.target.value });
  }

  useEffect(() => {

    if (userDetail != null) {
      let uDetail = JSON.parse(userDetail)
      setUserState({ full_name: uDetail.full_name })
      config.UserId = uDetail.customer_id
    }
  }, [])
  useEffect(() => {
    // Autofill from query params
    const params = new URLSearchParams(location.search);
    const name = params.get("name");
    const email = params.get("email");
    const whatsapp = params.get("whatsapp");

    setRegsterState(prev => ({
      ...prev,
      full_name: name || prev.full_name,
      email: email || prev.email,
      mobile_number: whatsapp || prev.mobile_number
    }));

   
  }, [location.search]);

  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000
  })


  const inputHandleChangeR = (e) => {
    const value = e.target.value;
    const text = e.target.name;
    setRegsterState({ ...regsterState, [text]: value })
  }

  const regitserButton = () => {
    // console.log("regsterState", regsterState);
    if (regsterState.email != "" && regsterState.password != "" && regsterState.full_name != "" && regsterState.company_name != "") {
      let full_api = config.apiUrl + `/user/register_api`;
      let sendData = regsterState;
      // console.log("bb", sendData);
      axios.post(full_api, sendData, { headers: config.headers }).then((res) => {
        // console.log("res ", res);
        if (res.data.isValid) {
          localStorage.setItem('ship_rocket_user', JSON.stringify(res.data.output));
          localStorage.setItem("kyc_checked", "false");
          localStorage.removeItem("hasSeenCarousel");
          setUserState({ full_name: res.data.output.full_name })
          config.UserId = res.data.output.customer_id
          Toast.fire({
            background: "#3659cd",
            type: 'success',
            title: res.data.message,
            color: "white"
          });
          setTimeout(() => {
            window.location.replace('/dashboard')
          }, 1000)
        }
        else {
          Toast.fire({
            background: "#206bc4",
            type: 'unsuccess',
            title: res.data.message,
            color: "white"
          });
        }

      }).catch((e) => {


      });
    } else {
      Toast.fire({
        background: "#a61c09",
        type: 'unsuccess',
        title: "Please fill all fields",
        color: "white"
      });
    }

  }



  return (
    <div>

      <section class="register_box_00">
        <div class="row justify-content-center ">
          <div class="col-xl-4 col-lg-5 col-sm-6 col-12 ">
            <form onSubmit={(e) => {
              e.preventDefault(); // Prevent the default form submission behavior
              regitserButton(); // Call your login function
            }} class="my-5">
              <div class="border rounded-2 p-4 mt-5 login_box">
                <div class="login-form">
                  <div class="text-center login-logo">
                    <a href="/login" class="mb-4 text-center">
                      <img src="assets/images/logo_big.png" class="img-fluid " alt="" />
                      {/* <h3 class="fw-bold">Skyship</h3> */}
                    </a>
                  </div>
                  <h5 class="fw-bold">Register Your Account</h5>
                  <p class="mb-5">Register your account to access the customer panel.</p>

                  <div class="mb-3">
                    <label class="form-label">Your Full Name</label>
                    <input type="text" class="form-control" placeholder="Enter your full name" name="full_name" onChange={(e) => inputHandleChangeR(e)} value={regsterState.full_name} />
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Your Brand Name (Not Company Name)</label>
                    <input type="text" class="form-control" placeholder="Enter your brand name" name="company_name" onChange={(e) => inputHandleChangeR(e)} />
                  </div>

                  <div class="mb-3">
                    <label class="form-label">Your Email</label>
                    <input type="email" class="form-control" placeholder="Enter your email" name="email" onChange={(e) => inputHandleChangeR(e)} value={regsterState.email} />
                  </div>
                  <div class="mb-3">
                    <label class="form-label">Your Mobile</label>
                    <input type="number" class="form-control" placeholder="Enter your mobile" name="mobile_number" onChange={(e) => inputHandleChangeR(e)}value={regsterState.mobile_number} />
                  </div>
                        <div class=" mb-3">
                            <label for="" class="form-label">State </label>
                            <select class="form-select w-100 mb-0" id="state" name="state" aria-label="State select example" onChange={(e)=>handleSelectState(e)} >
                                                          <option >State</option>
                                                                {statelist.map((sub)=>(
                                                                    <option value={sub.state_id}>{sub.state_name}</option> 
                                                                ))}
                                                            </select>
                        </div>
                        {/* <div class="mb-3">
                            <label for="" class="form-label">City </label>
                            <select class="form-select w-100 mb-0" id="state" name="city" aria-label="State select example" onChange={(e)=>handleSelectCity(e)} >
                                                             <option >City</option>
                                                               
                                                                {citylist.map((sub)=>(
                                                                    <option value={sub.city_id}>{sub.city_name}</option> 
                                                                ))}
                                                            </select>
                        </div> */}
                  {/* <div class="mb-3">
                    <label class="form-label">Referral Code</label>
                    <input type="text" class="form-control" placeholder="Enter Referral Code (Optional)" name="referral_code" onChange={(e) => inputHandleChangeR(e)} />
                  </div> */}

                  <div class="mb-3">
                    <label class="form-label">Create Password</label>
                    <input type="password" class="form-control" placeholder="Enter password" name="password" onChange={(e) => inputHandleChangeR(e)} />
                  </div>

                  <div class="d-flex align-items-center justify-content-between">
                    <div class="form-check m-0">
                      <input class="form-check-input" type="checkbox" value="" id="rememberPassword" checked />
                      <label class="form-check-label" for="rememberPassword">I accept all  <a href="https://skyship.com/terms.php" target="_blank" class="text-primary">
                        Terms & Conditions </a>and <a href="https://skyship.com/policy.php" target="_blank" class="text-primary">Privacy Policy</a>
                      </label>
                    </div>
                  </div>
                  <div class="d-grid py-3 mt-4">
                    <button type="submit" style={{ cursor: "pointer" }} class="btn btn-lg btn-primary">
                      Register Account
                    </button>
                  </div>
                  <div class="text-center pt-4">
                    <a href="/login" class="text-blue text-decoration-underline ms-2">
                      Return to Login</a>
                  </div>
                </div>
              </div>
            </form>



            {/* <div class="">
        <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" href="https://skyship.com/terms.php" target="_blank">Terms &amp; Condition</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://skyship.com/policy.php" target="_blank">Privacy Policy</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://skyship.com/help.php" target="_blank">Help</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://skyship.com/contact.php" target="_blank">Contact</a>
            </li>
        </ul>
      </div> */}
          </div>
        </div>

      </section>

    </div>
  )
}

export default Register
